import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store/store";
import WebsiteRoutes from "./routes/WebsiteRoutes";
import DashboardRoutes from "./routes/DashboardRoutes";
import ProtectedRoute from "./auth/ProtectedRoute";
import { InstagramProvider } from "./contexts/InstagramContexts"
import "./index.css";
import "react-day-picker/style.css";
import Login from "./auth/login";
import ScrollToTop from "./components/ScrollToTop";

export default function App() {
  return (
    <Provider store={store}>
      <InstagramProvider>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <ScrollToTop />
            <Routes>
              <Route path="/*" element={<WebsiteRoutes />} />
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/control/*" element={<DashboardRoutes />} />
              </Route>
            </Routes>
          </Router>
        </PersistGate>
      </InstagramProvider>
    </Provider>
  );
}
